"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.common.yes': 'Yes',
    'profession.common.no': 'No',
};
